import { action } from 'app/actions';

export const GET_GROUPS = 'classesStudents/GET_GROUPS';
export const getGroups = payload => action(GET_GROUPS, { payload });

export const REMOVE_GROUP = 'classesStudents/REMOVE_GROUP';
export const removeGroup = payload => action(REMOVE_GROUP, { payload });

export const GET_SCHOOLS = 'classesStudents/GET_SCHOOLS';
export const getSchools = () => action(GET_SCHOOLS);

export const MASSIVE_LOAD_GROUPS = 'classesStudents/MASSIVE_LOAD_GROUPS';
export const massiveLoadGroups = payload => action(MASSIVE_LOAD_GROUPS, { payload });

export const RESET_MASSIVE_LOAD_GROUPS = 'classesStudents/RESET_MASSIVE_LOAD_GROUPS';
export const resetMassiveLoadGroups = payload => action(RESET_MASSIVE_LOAD_GROUPS, { payload });

export const FILTER_CLASSES = 'classesStudents/FILTER_CLASSES';
export const filterClasses = payload => action(FILTER_CLASSES, { payload });
